/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Approvals_WaitingInputs */

const en_queue_approvals_waiting = /** @type {(inputs: Queue_Approvals_WaitingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Approvals waiting`)
};

/**
* | output |
* | --- |
* | "Approvals waiting" |
*
* @param {Queue_Approvals_WaitingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_approvals_waiting = /** @type {((inputs?: Queue_Approvals_WaitingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Approvals_WaitingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_approvals_waiting(inputs)
});